@if (businessPartnerId(); as businessPartnerId) {
  <pfx-business-partner-sidebar
    [businessPartnerId]="businessPartnerId"
    [visible]="viewBusinessPartner()"
    (visibleChange)="handleSidebarVisibleChanged($event)"
  >
  </pfx-business-partner-sidebar>
}
